const actionTypes = {
  MENU_TRIGGER_UP: 0,
  MENU_ITEM_UP: 1,
  MENU_TRIGGER_DOWN: 2,
  MENU_ITEM_DOWN: 3,
  MENU_ITEM_ENTER: 4,
  MENU_ITEM_SPACE: 5,
  MENU_ITEM_CLICK: 6,
  MENU_ITEM_HOVER: 7,
  MENU_TRIGGER_ENTER: 8,
  MENU_TRIGGER_SPACE: 9,
  MENU_TRIGGER_CLICK: 10,
  MENU_CLOSE: 11
};
export {
  actionTypes
};
